import {API} from '@chekin/api';
import {useEvent} from '@chekinapp/ui';
import {useCallback} from 'react';
import {safeCaptureException} from '../../../utils';

type UseLivenessVideoUploadProps = {
  onUploadFinished: (value: string) => void;
};

function useLivenessVideoUpload({onUploadFinished}: UseLivenessVideoUploadProps) {
  const handleOnUploadFinished = useEvent(onUploadFinished);

  const uploadLivenessVideo = useCallback(
    async (recordingVideo?: Blob | null): Promise<string | undefined> => {
      if (!recordingVideo) return undefined;

      try {
        const response = await API.guest.uploadLivenessVideo(recordingVideo);

        handleOnUploadFinished(response.key);
        return response.key;
      } catch (error) {
        safeCaptureException(error, 'Document selfie detection error');
        console.error('Document selfie detection error:', error);
        return undefined;
      }
    },
    [handleOnUploadFinished],
  );

  return {uploadLivenessVideo};
}

export {useLivenessVideoUpload};
